import * as React from 'react';
import { Heading } from '@built/design-system';

import Footer from '../components/Footer';
import * as styles from './Maintenance.module.scss';
import maintenanceGraphic from '../images/icon-maintenance.svg';
import builtLogo from '../images/img-built-logo.svg';
import l10n from '@built/i18n';

export default function Maintenance(props: MaintenanceProps) {
  return (
    <div className={styles.maintenanceBlock}>
      <img
        src={maintenanceGraphic}
        className={styles.maintenanceIcon}
        alt="Maintenance Icon"
      />
      <div className={styles.logo}>
        <img src={builtLogo} alt="Built Logo" />
      </div>
      <Heading size="xxl" className={styles.headline}>
        Built is currently performing maintenance.
      </Heading>
      <p className={styles.large}>
        {l10n.t(
          'Maintenance:wereCurrentlyAddingMoreNutsAndBoltsTo',
          "We're currently adding more nuts and bolts to the Built platform and should be back up and running shortly."
        )}
      </p>
      <p className={styles.large}>
        <strong>
          {l10n.t(
            'Maintenance:thankYouForYourPatience',
            'Thank you for your patience!'
          )}{' '}
        </strong>
      </p>
      <Footer basic={true} className={styles.footer} />
    </div>
  );
}

export interface MaintenanceProps {}
